import { render, staticRenderFns } from "./ticket-list.vue?vue&type=template&id=8167a1ce"
import script from "./ticket-list.vue?vue&type=script&lang=js"
export * from "./ticket-list.vue?vue&type=script&lang=js"
import style0 from "./ticket-list.vue?vue&type=style&index=0&id=8167a1ce&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8167a1ce')) {
      api.createRecord('8167a1ce', component.options)
    } else {
      api.reload('8167a1ce', component.options)
    }
    module.hot.accept("./ticket-list.vue?vue&type=template&id=8167a1ce", function () {
      api.rerender('8167a1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/customer-service/ticket-list.vue"
export default component.exports